import script from "./MainAdsSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainAdsSwiper.vue?vue&type=script&setup=true&lang=ts"

import "./MainAdsSwiper.vue?vue&type=style&index=0&id=465bb0d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465bb0d6"]])

export default __exports__